import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';




export default class YouWin extends React.Component {
    render() {
        return (
        
              <header className="App-header">
                      
                    
              <h2>YOU WIN!!!</h2>
              <p>You have outwitted Evil Corp.</p>
            
  
            </header>
      
        )
    }
  }

